import React, {useEffect, useState} from "react";
import axios from "axios";
import {ApiUrl} from "../../../auth/authMethods";
import Popup from "../../../component/Popup/Popup";
import {
    Button,
    Divider,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from "@mui/material";
import BasicLoader from "../../../component/BasicLoader/BasicLoader";
import LoadingButton from "@mui/lab/LoadingButton";
import DownloadIcon from "@mui/icons-material/Download";
import DeleteIcon from "@mui/icons-material/Delete";
import UploadFileIcon from '@mui/icons-material/UploadFile';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import SendIcon from '@mui/icons-material/Send';

export default function PopupConsentFile({pedidoId}) {

    const [lgShow, setLgShow] = useState(false);

    const title = 'Arquivo de Anuência';

    const button = <>
        <UploadFileIcon fontSize="medium"/> &nbsp; {title}
    </>;


    const iconSpan = <>
        <UploadFileIcon fontSize="large" id="icon-svg"/>
        <h3>{title}</h3>
    </>

    const [file, setFile] = useState(null);
    const [consentFile, setConsentFile] = useState({});

    const [isLoading, setIsLoading] = useState(true);

    const [isLoadingUpload, setIsLoadingUpload] = useState(false);
    const [isLoadingRemove, setIsLoadingRemove] = useState([]);

    const [isLoadingSend, setIsLoadingSend] = useState(false);

    useEffect(() => {
        // Fetch existing file for the given pedidoId
        axios.get(`${ApiUrl}/arquivoAnuencia/pedido/${pedidoId}`)
            .then(response => {
                setConsentFile(response.data);
                setFile(null)
            })
            .catch(error => {
                console.error("There was an error fetching the file!", error);
            })
            .finally(() => {
                setIsLoading(false)
            });
    }, [pedidoId]);

    const handleAddFile = (event) => {
        const selectedFiles = event.target.files[0];
        setFile(selectedFiles);
    };

    const handleRemoveFile = (index) => {
        setFile(null);
    };

    const handleRemoveExistingFile = (fileId) => {
        setIsLoadingRemove(true)

        setIsLoadingRemove([...isLoadingRemove, fileId])
        axios.delete(`${ApiUrl}/arquivoAnuencia/${fileId}`)
            .then(response => {
                setConsentFile({});
            })
            .catch(error => {
                console.error("There was an error deleting the file!", error);
            })
            .finally(() => {
                setIsLoadingRemove(isLoadingRemove.splice(isLoadingRemove.indexOf(fileId), 1))
            });
    };

    const handleDownloadFile = (file) => {
        const byteCharacters = atob(file.data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], {type: 'application/octet-stream'});
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', file.fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleUploadFiles = () => {
        const formData = new FormData();
        formData.append('files', file);
        formData.append('pedidoId', pedidoId);

        setIsLoadingUpload(true)
        axios.post(`${ApiUrl}/arquivoAnuencia/upload`, formData)
            .then(response => {
                setConsentFile(response.data);
                setFile(null);
                // setLgShow(false);
            })
            .catch(error => {
                console.error("There was an error uploading the file!", error);
            })
            .finally(() => {
                setIsLoadingUpload(false)
            });
    };

    const handleSentFile = () => {
        setIsLoadingSend(true)
        axios.post(`${ApiUrl}/arquivoAnuencia/send/${pedidoId}`)
            .then(response => {
                setConsentFile(prevData => {
                    return {...prevData, sent: true}
                })
            })
            .catch(error => {
                console.error("Erro ao enviar arquivo!", error);
            })
            .finally(() => {
                setIsLoadingSend(false)
            });
    }

    return (
        <>
            <Popup
                buttonText={button}
                title={title}
                iconSpan={iconSpan}
                lgShow={lgShow} setLgShow={setLgShow}
                buttonClass={'dropdown-item'}
            >
                <Typography variant="h6" gutterBottom>
                    Documento
                </Typography>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Nome do Documento</TableCell>
                                <TableCell>Ações</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {(isLoading) ?

                                <tr>
                                    <td colSpan={2}>
                                        <BasicLoader message='Buscando arquivos...' height={10}/>
                                    </td>
                                </tr> :
                                (consentFile.fileName ? <>
                                    <TableRow key={consentFile.id}>
                                        <TableCell>{consentFile.fileName}</TableCell>
                                        <TableCell>
                                            <LoadingButton
                                                title='Fazer download do arquivo'
                                                onClick={() => handleDownloadFile(consentFile)}
                                                variant="text"
                                            >
                                                <DownloadIcon/>
                                            </LoadingButton>
                                            <LoadingButton
                                                title='Excluir arquivo'
                                                loading={isLoadingRemove.find(id => id === consentFile.id)}
                                                onClick={() => handleRemoveExistingFile(consentFile.id)}
                                                variant="text"
                                                color='error'
                                            >
                                                <DeleteIcon/>
                                            </LoadingButton>
                                        </TableCell>
                                    </TableRow>

                                </> : <></>)
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
                <br/>
                <Divider/>
                <br/>
                {!isLoading && !consentFile.id && <>
                    <Typography variant="h6" gutterBottom>
                        Adicionar arquivo
                    </Typography>
                    {file !== null && <ul>
                        <li key={1}>
                            {file?.name}
                            <IconButton onClick={() => handleRemoveFile(1)} aria-label="remove file">
                                <DeleteIcon/>
                            </IconButton>
                        </li>
                    </ul>}

                    <input
                        accept="image/*,application/pdf"
                        style={{display: 'none'}}
                        id="contained-button-file"
                        type="file"
                        onChange={handleAddFile}
                    />
                    <label htmlFor="contained-button-file">
                        <Button variant="contained" color="primary" component="span" style={{marginRight: '10px'}}>
                            Adicionar Arquivo
                        </Button>
                    </label>

                    <Button
                        variant="contained"
                        color={(isLoadingUpload || file === null) ? "secondary" : "primary"}
                        onClick={handleUploadFiles}
                        disabled={isLoadingUpload || file === null}
                    >
                        {isLoadingUpload ? (
                            <>
                                    <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>
                                &nbsp;Salvando...
                            </>
                        ) : (
                            "Salvar"
                        )}
                    </Button>
                </>}
                {consentFile.id &&
                    <div className='d-flex'>
                        {consentFile.sent ?
                            <div className='d-flex text-center text-success mt-1'>
                                <CheckCircleIcon fontSize="medium"/>
                                &nbsp;Arquivo já enviado
                            </div> :
                            <div className='d-flex text-center text-danger mt-1'>
                                <CancelIcon fontSize="medium"/>
                                &nbsp;Arquivo não enviado
                            </div>
                        }
                        &nbsp;&nbsp;
                        <LoadingButton
                            onClick={handleSentFile}
                            loading={isLoadingSend}
                            loadingPosition="start"
                            startIcon={<SendIcon/>}
                            variant="contained"
                            className={''}
                        >
                            <span>
                                &nbsp;{consentFile.sent? "Reenviar" : "Enviar" } para o comprador
                            </span>
                        </LoadingButton>
                    </div>
                }

            </Popup>
        </>
    );
}
